import React from "react";

function WisdomTeethRemoval() {
  return <div>Wisdom Teeth Removal</div>;
}

export default WisdomTeethRemoval;
